import React from "react"
import { $SiteColors } from "../../../common/config/company-atts"

interface ICircle {
  isBusHere: boolean,
  isClickedPoint: boolean
}

export const Circle = ({isClickedPoint, isBusHere}: ICircle) => {
  //если в данной точке, находиться машина, то задний фон круга меняем на белый,
  // иначе если эта точка, на которую нажали на карте, то задний фон круга меняем на черный цвет,
  //в противном случае задний фон круга берем общий
  const back = isBusHere ? "white" : isClickedPoint ? "black" : $SiteColors.getState().backRoutePanel
  const borderColor = isClickedPoint ? "black" : "white" //если эта точка, на которую нажали на карте, то границы груга меняем на черный цвет
  const divStyle = {
    background: back,
    borderRadius: "50%",
    width: "20px",
    border: '2px solid ' + borderColor,
    height: '20px'
  } as React.CSSProperties

  return (
    <div style={divStyle}></div>
  )
}
